import {makeAutoObservable} from 'mobx'

export default class InstitutionMonthlyReport {
  id: number

  institutionId: number

  month: number

  numericYear: number

  actualStipendPaidDate: Date

  constructor(data: any) {
    this.id = data.Id ?? data.id ?? 0
    this.institutionId = data.InstitutionId ?? data.institutionId
    this.month = data.Month ?? data.month
    this.numericYear = data.NumericYear ?? data.numericYear
    this.actualStipendPaidDate = new Date(data.ActualStipendPaidDate ?? data.actualStipendPaidDate)
    makeAutoObservable(this)
  }
}
